import { useEffect, useState } from "react";

export const Typewriter = ({ lines, speed = 50, startDelay = 300 }) => {
  const full = lines.join("\n");
  const [count, setCount] = useState(0);

  useEffect(() => {
    let interval;
    const timeout = setTimeout(() => {
      interval = setInterval(() => {
        setCount((c) => {
          if (c >= full.length) {
            clearInterval(interval);
            return c;
          }
          return c + 1;
        });
      }, speed);
    }, startDelay);
    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, [full, speed, startDelay]);

  const typed = full.slice(0, count).split("\n");

  return (
    <>
      {typed.map((line, i) => (
        <span key={i}>
          {line}
          {i < typed.length - 1 && <br />}
        </span>
      ))}
      <span className="tw-caret" aria-hidden="true" />
    </>
  );
};
